<div class="fixed">
  @if (show) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- <div
  id="pause"
  *ngIf="show"
  class="d-flex align-items-center justify-content-center"
  >
  <div id="spinner"></div>
</div> -->
</div>
